<template>
  <div class="import-j4">
    <h2>Importar J4 - SAMU</h2>

    <div>
      <label>Equipe:</label>
      <v-select
        v-model="selectedEquipe"
        :options="equipes"
        label="EquipeDS"
        :reduce="e => e.EquipeID"
        placeholder="Selecione uma equipe"
        :clearable="false"
      />
    </div>

    <div>
      <label>Data Inicial:</label>
      <input
        v-model="dataInicial"
        type="date"
      >
    </div>

    <div>
      <label>Data Final:</label>
      <input
        v-model="dataFinal"
        type="date"
      >
    </div>

    <button
      :disabled="!canImport || loading"
      @click="importarJ4"
    >
      Importar J4
    </button>

    <div
      v-if="mensagem"
      :class="{'success': sucesso, 'error': !sucesso}"
      style="margin-top:10px;"
    >
      {{ mensagem }}
    </div>

    <div
      v-if="resultados.length"
      class="resultados"
    >
      <h3>Resultados da Importação</h3>
      <table>
        <thead>
          <tr>
            <th>CPF</th>
            <th>Nome</th>
            <th>Status</th>
            <th>Mensagem</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="r in resultados"
            :key="r.cpf"
          >
            <td>{{ r.cpf }}</td>
            <td>{{ r.nome }}</td>
            <td :class="{'success': r.sucesso, 'error': !r.sucesso}">
              {{ r.sucesso ? 'Atualizado' : 'Erro' }}
            </td>
            <td>{{ r.mensagem }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-if="equipesImportadas.length"
      class="importadas"
    >
      <h3>Equipes Importadas</h3>
      <ul>
        <li
          v-for="e in equipesImportadas"
          :key="e"
        >
          {{ e }}
        </li>
      </ul>
    </div>

    <div
      v-if="usuariosImportados.length"
      class="usuarios-importados"
    >
      <h3>Usuários Importados</h3>
      <table>
        <thead>
          <tr>
            <th>CPF</th>
            <th>Nome</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="u in usuariosImportados"
            :key="u.cpf"
          >
            <td>{{ u.cpf }}</td>
            <td>{{ u.nome }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-if="erros.length"
      class="erros-importacao"
    >
      <h3>Erros</h3>
      <table>
        <thead>
          <tr>
            <th>CPF</th>
            <th>Nome</th>
            <th>Mensagem</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="err in erros"
            :key="err.cpf"
          >
            <td>{{ err.cpf }}</td>
            <td>{{ err.nome }}</td>
            <td class="error">
              {{ err.mensagem }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const api = axios.create({
  baseURL: 'https://chronosapi.it4d.com.br',
})

export default {
  name: 'ImportarJ4',
  data() {
    return {
      equipes: [],
      selectedEquipe: '',
      dataInicial: '',
      dataFinal: '',
      mensagem: '',
      sucesso: false,
      resultados: [],
      loading: false,
      equipesImportadas: [],
      usuariosImportados: [],
      erros: [],
    }
  },
  computed: {
    canImport() {
      return this.selectedEquipe && this.dataInicial && this.dataFinal
    },
  },
  mounted() {
    this.fetchEquipes()
  },
  methods: {
    async fetchEquipes() {
      try {
        const res = await api.get('/api/consulta/equipes')
        this.equipes = res.data || []
      } catch (e) {
        this.mensagem = 'Erro ao buscar equipes.'
        this.sucesso = false
      }
    },
    async importarJ4() {
      this.mensagem = ''
      this.sucesso = false
      this.resultados = []
      this.loading = true
      try {
        const payload = {
          equipes: [Number(this.selectedEquipe)],
          data_inicial: this.dataInicial,
          data_final: this.dataFinal,
        }
        const res = await api.post('/api/importar-j4', payload)
        // Adaptação para o novo formato do backend
        this.sucesso = !!res.data.success
        this.mensagem = res.data.message || (this.sucesso ? 'Importação realizada!' : 'Erro ao importar J4.')
        // Exibe equipes importadas e usuários
        this.equipesImportadas = res.data.equipes_importadas || []
        this.usuariosImportados = res.data.usuarios_importados || []
        this.erros = res.data.erros || []
      } catch (e) {
        this.sucesso = false
        if (e.response && e.response.data) {
          this.mensagem = e.response.data.message || 'Erro ao importar J4.'
          this.equipesImportadas = e.response.data.equipes_importadas || []
          this.usuariosImportados = e.response.data.usuarios_importados || []
          this.erros = e.response.data.erros || []
        } else {
          this.mensagem = 'Erro ao importar J4.'
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.import-j4 {
  max-width: 500px;
  margin: 30px auto;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fafbfc;
}
.import-j4 label {
  display: block;
  margin-top: 10px;
}
.import-j4 select,
.import-j4 input[type="date"] {
  width: 100%;
  padding: 6px;
  margin-top: 2px;
  margin-bottom: 10px;
}
.import-j4 button {
  margin-top: 10px;
  padding: 8px 16px;
}
.success { color: green; }
.error { color: red; }
.resultados {
  margin-top: 20px;
}
.resultados table {
  width: 100%;
  border-collapse: collapse;
}
.resultados th, .resultados td {
  border: 1px solid #ccc;
  padding: 6px 8px;
  text-align: left;
}
.importadas, .usuarios-importados, .erros-importacao {
  margin-top: 24px;
}
.importadas ul {
  padding-left: 18px;
}
.usuarios-importados table, .erros-importacao table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}
.usuarios-importados th, .usuarios-importados td,
.erros-importacao th, .erros-importacao td {
  border: 1px solid #ccc;
  padding: 6px 8px;
  text-align: left;
}
.erros-importacao td.error {
  color: #d32f2f;
  font-weight: bold;
}
</style>
